import type { CurrencyCode } from "@/lib/api/permalinks";

/**
 * Render a numeric price as the storefront displays it: currency code in
 * front of the amount, e.g. `CAD $24.99`. The currency code is configured
 * in the NPharmacy plugin (Settings → Storefront currency) and threaded
 * through React via `CurrencyContext` (`useCurrency()`).
 */
export function formatPrice(
  amount: number | string,
  currency: CurrencyCode = "CAD",
): string {
  const num = typeof amount === "number" ? amount : Number(amount);
  const safe = Number.isFinite(num) ? num : 0;
  return `${currency} $${safe.toFixed(2)}`;
}
